import React from "react";

function SellerInfoCard({ seller, productCount }) {
  if (!seller) {
    return null;
  }

  return (
    <div className="seller-card">
      <div
        className="seller-card-banner"
        style={{
          backgroundImage: `url(${seller.banner || seller.logo || "/default-logo.png"})`,
        }}
      />

      <div className="seller-logo-wrap">
        <img
          src={seller.logo || "/default-logo.png"}
          alt={seller.shop_name || seller.name || "Seller"}
          className="seller-logo"
        />
      </div>

      <p className="seller-name">{seller.shop_name || seller.name}</p>

      {seller.seller_info && (
        <div className="seller-info-box">
          <p>{seller.seller_info}</p>
        </div>
      )}

      <div className="seller-rating">
        <span className="seller-rating-stars">
          &#9733;&#9733;&#9733;&#9733;<span>&#9733;</span>
        </span>
        <span className="seller-rating-count">(189)</span>
      </div>

      <div className="seller-stats">
        <div className="seller-stat">
          <strong>{productCount ?? seller.product_count ?? 0}</strong>
          <span>Products</span>
        </div>

        <div className="seller-stat">
          <strong>4.8</strong>
          <span>Rating</span>
        </div>
      </div>

      <div className="seller-actions">
        <button className="follow-btn" type="button">
          Follow
        </button>

        <button className="share-btn" type="button">
          Share
        </button>
      </div>
    </div>
  );
}

export default SellerInfoCard;
